import {
  Field,
  FieldDataType,
  ModuleInventoryDirection,
} from './../module-structure';
import { ModuleStructure, Section } from 'src/app/models/module-structure';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FieldValueChangedArgs } from 'src/app/layout/field-value-changed-args';
import { LayoutService } from 'src/app/layout/layout.service';
import {
  EventType,
  PriceQueueRequest,
  RecordCategory,
  RecordModel,
  RecordProperties,
} from 'src/app/layout/record-model';
import * as moment from 'moment';
import * as g from 'src/app/globals';

let moduleHeaderData;
export function setModuleHeaderData(data) {
  moduleHeaderData = data;
}
export class ServiceCall {
  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService
  ) {
    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      if (args.recordModel.ObjectCode === '191') {
        this.serivceCallDocument(args);
      }
    });
    layoutService.objectLoadChanged.subscribe((args: FieldValueChangedArgs) => {
      if (args.recordModel.ObjectCode === '191') {
        this.serviceCallLoad(args);
      }
    });
  }

  serivceCallDocument(args: FieldValueChangedArgs) {
    if (args.recordProperty.FieldName === 'manufSN') {
      console.log(moduleHeaderData);
      const properties = args.recordModel.Categories.find(
        (x) => x.Id === args.sectionTagName
      ).Lines[args.line].Properties;
      properties.forEach((property) => {
        if (
          [
            'internalSN',
            'itemCode',
            'itemName',
            'itemGroup',
            'customer',
            'custmrName',
          ].indexOf(property.FieldName) > -1 ||
          property.FieldName.startsWith('U_')
        ) {
          let value = moduleHeaderData[property.FieldName];
          if (value != null && value !== '' && value !== '') {
            if (property.DataType === FieldDataType.Date) {
              value = moment(value).format();
            }
            LayoutService.setValue(
              property,
              value,
              this.layoutService,
              args.recordModel,
              args.line,
              args.sectionTagName,
              args.moduleStructure
            );
          }
        }
      });
    }
  }
  serviceCallLoad(args: FieldValueChangedArgs) {
    const duration = args.recordModel.Categories.find(
      (x) => x.Id === 'ServiceCalls'
    ).Lines[0].Properties.find((x) => x.FieldName === 'Duration');
    const durationType = args.recordModel.Categories.find(
      (x) => x.Id === 'ServiceCalls'
    ).Lines[0].Properties.find((x) => x.FieldName === 'DurType');
    const options: { Code: string; Name: string }[] = [
      { Code: 'M', Name: 'Minutes' },
      { Code: 'H', Name: 'Hours' },
      { Code: 'D', Name: 'Days' },
    ];
    if (durationType == null) {
      return;
    }
    durationType.Options = options;
    if (durationType.Value === 'S') {
      const durationInMinutes = duration.ValueAsObject / 60;
      if (durationInMinutes > 60) {
        duration.ValueAsObject = durationInMinutes / 60;
        LayoutService.setValue(
          durationType,
          'H',
          this.layoutService,
          args.recordModel,
          0,
          'ServiceCalls',
          args.moduleStructure
        );
        // durationType.Value = 'H';
        // durationType.ValueAsObject = 'H';
      } else {
        duration.ValueAsObject = durationInMinutes;
        LayoutService.setValue(
          durationType,
          'M',
          this.layoutService,
          args.recordModel,
          0,
          'ServiceCalls',
          args.moduleStructure
        );
        // durationType.Value = 'M';
        // durationType.ValueAsObject = 'M';
      }
    }
  }
}
